exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._1LhFk87NhWJnPgNqdIa3Jp,html[dir] ._3_DpDLB2CG-BAemhQ-jy5A{margin-top:10px}html[dir=ltr] ._1PJlgoUqE1hdvY7dZeYCq9{margin-right:4px}html[dir=rtl] ._1PJlgoUqE1hdvY7dZeYCq9{margin-left:4px}", ""]);

// exports
exports.locals = {
	"calendarFolderContainer": "_3_DpDLB2CG-BAemhQ-jy5A",
	"settingsContainer": "_1LhFk87NhWJnPgNqdIa3Jp",
	"settingsDescription": "_1PJlgoUqE1hdvY7dZeYCq9"
};